import { request } from '../../helpers/api/request';
import { GetFaqListContract, GetFaqListParams } from '../../types/Endpoints/faq/FaqContracts';

export const getFaqList = async (params: GetFaqListParams) => {
    const { data } = await request<GetFaqListContract>({
        url: 'admin/faq',
        method: 'GET',
        params,
    });

    return data;
};
